<template>
  <div
    :class="['dropdown', { disabled, 'overflow-hidden': overflowHidden }]"
    v-click-outside="close"
    @keydown.esc="close"
  >
    <slot />

    <div
      v-show="active"
      class="dropdown-content"
      :class="[align, { flex }]"
    >
      <slot name="menu" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    align: {
      type: String,
      options: ['left', 'right', 'top-right', 'top-left', 'center'],
      default: 'left',
    },
    disabled: Boolean,
    flex: Boolean,
    overflowHidden: Boolean,
  },

  methods: {
    close(e) {
      if (this.active) {
        e.stopPropagation();
      }

      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: inline-flex;

  &:not(.disabled) {
    cursor: pointer;
  }

  &.overflow-hidden {
    overflow: hidden;
  }
}

.dropdown-content {
  position: absolute;
  z-index: 6;
  user-select: none;

  &.flex {
    width: 100%;
  }

  &.left {
    left: 0;
    top: 100%;
  }

  &.right {
    right: 0;
    top: 100%;
  }

  &.top-left {
    left: 0;
    bottom: 100%;
  }

  &.top-right {
    right: 0;
    bottom: 100%;
  }

  &.center {
    left: 50%;
    transform: translateX(-50%);
    top: 100%;
  }
}
</style>
